import { BusinessStatsResponse } from "features/performance/index.types";
import { FiltersProps } from "utils/types";

const SEOExportKeys = [
  { header: "Slug", key: "slug" },
  { header: "Title", key: "title" },
  { header: "H1 Tags", key: "h1" },
  { header: "Keywords", key: "keywords" },
  { header: "Description", key: "description" },
];

// Business IDs
export const IQBAL_BUSINESS_ID = 12092,
  TEZMART_BUSINESS_ID = 12154,
  APNA_FORM_BUSINESS_ID = 12185,
  DWP_BUSINESS_ID = 12230,
  DWP_STAGING_BUSINESS_ID = 12180,
  AMANAT_STAGING_BUSINESS_ID = 12208,
  AMANAT_BUSINESS_ID = 12257,
  // Pusher package details
  pusher_app_id = "343321",
  pusher_key = "716e48f84200df7be2f2",
  pusher_secret_key = "eba926c876d17fba6174",
  // chatbot details
  TAWK_TO_API_KEY = "569c5cb4cc9823580beb8341e4192e21ce48aec2",
  TAWK_PROPERTY_ID = "576c2a47755e803425bf96fd",
  // excel base date
  excelBaseDate = "1899-12-30",
  // tinyMCE editor key
  // TODO: key changed temporarily
  // TINY_EDITOR_API_KEY = "00f31vkt0j9pkd1pt5g9vqgfdfog3kvmzjtsfsyfi5mcbit0",
  // TINY_EDITOR_API_KEY = "tuvzuru0x0a4czyv3e81d1vtokavrrc1d6hkm6556ttq635w",
  // TINY_EDITOR_API_KEY = "e6v5yv5zpgqmmvdzwt9y2wyna3vv3l53qcswi1hzykcuh67k",
  // TINY_EDITOR_API_KEY = "361pmskg4h1flfnlg0gpppuvi55p4p6guc8e2m6k65mls3i4",
  TINY_EDITOR_API_KEY = "guas5aod7wit2uey1zbwttut8mx7tdpusnzgz6ge9l6rl2y4",
  // Google Map Key
  GOOGLE_MAP_API_KEY = "AIzaSyBDSFpPJvFMd1FF7g_JC8dLKf_SwAdL3SQ",
  // firebase configuration
  FIREBASE_APP = {
    apiKey: "AIzaSyDq-JLnuAexC9AOIeig3riC1yzHA443FzY",
    authDomain: "tossdown-biz.firebaseapp.com",
    projectId: "tossdown-biz",
    storageBucket: "tossdown-biz.appspot.com",
    messagingSenderId: "897297031591",
    appId: "1:897297031591:web:d47f7c824468de4784d682",
    measurementId: "G-L9B5V997VZ",
  },
  //
  /* Regexs
  -------
  - small and capital alphabets
  - positive numbers
  - not more than one hyphen or Minus sign */
  alphaNumericRegex = /^[a-zA-Z0-9 &\-\(\)]*$/,
  seoTagsRegex = /^[a-zA-Z0-9-_. /,|!<>]*$/,
  singleDoubleQuotesRegex = /^[a-zA-Z0-9-_.'"/,|!<> =:*;&+$?%#-\[\]]*$/,
  //regular expression that will allow maximum 2 decimal
  decimalRegExp = /^\d+(\.\d{1,2})?$/,
  productNameRegex = /^[a-zA-Z0-9.,:;/|()&*<>"'@#$%^_+= -]*$/,
  newValidateEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  validateEmailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/,
  // allow only alpha numeric without any special character
  onlyalphaNumeric = /^[a-zA-Z0-9]*$/,
  // only single/double quotes and 'Enter' key are restricted
  restrictedKeys = /[\r\n'"]/,
  restrictOnlyRegex = /^[^`'"/]*$/, // only single double quotes and forward slach are restricted
  numericAndFractionValues = /^[0-9]+(\.[0-9]+)?$/, // only the integer and fraction values are allowed
  source = "biz",
  // background image
  backgroundImage =
    "https://static.tossdown.com/site/b8bb6888-035a-4c00-a5bf-a2bc2f1a6c94.webp",
  // color used in charts
  colorPalette = {
    tossdown_color: "#DB154D",
    gray: "#455A64",
    dark_blue: "#24335E",
  },
  // Static Array and Objects
  salesByPlatform = [
    {
      label: "Website",
      borderColor: colorPalette["tossdown_color"],
      backgroundColor: colorPalette["tossdown_color"],
      borderWidth: 2,
      data: [],
    },
    {
      label: "App",
      borderColor: colorPalette["dark_blue"],
      backgroundColor: colorPalette["dark_blue"],
      borderWidth: 2,
      data: [],
    },
    {
      label: "POS",
      borderColor: colorPalette["gray"],
      backgroundColor: colorPalette["gray"],
      borderWidth: 2,
      data: [],
    },
  ],
  seoTrafficData = [
    {
      label: "Organic Search",
      borderColor: colorPalette["tossdown_color"],
      backgroundColor: colorPalette["tossdown_color"],
      borderWidth: 2,
      data: [],
    },
  ],
  OrderDetailColumns = [
    { header: "Item #", key: "item_no" },
    { header: "Category", key: "category" },
    { header: "Item ID", key: "item_id" },
    { header: "Item Name", key: "item_name" },
    { header: "Brand", key: "brand" },
    { header: "Quantity", key: "quantity" },
    { header: "Weight", key: "weight" },
    { header: "Price", key: "price" },
    { header: "Amount", key: "amount" },
    { header: "Total", key: "total" },
    { header: "Options", key: "options" },
    { header: "Note", key: "note" },
    { header: "Instructions", key: "instructions" },
  ],
  orderListingColumns = [
    { header: "Order ID", key: "order_id", export: true },
    { header: "Status", key: "status", export: false },
    { header: "Name", key: "name", export: true },
    { header: "Grand Total", key: "grand_total", export: false },
    { header: "Payment Method", key: "payment_type", export: false },
    { header: "Order Type", key: "order_type", export: true },
    { header: "Branch", key: "eatout_location", export: true },
    { header: "Placement Date", key: "date", export: true },
    { header: "Fulfillment Date", key: "delivery_date", export: true },
    { header: "Area", key: "user_area", export: false },
    { header: "Address", key: "address", export: false },
    { header: "City", key: "user_city", export: false },
    { header: "Mobile No", key: "mobile_number", export: false },
    { header: "Email", key: "user_email", export: false },
    { header: "Staff note", key: "landline_number", export: false },
    { header: "Note", key: "note", export: true },
    { header: "Source", key: "source", export: false },
    { header: "Tip", key: "tip", export: false },
    { header: "CNIC", key: "cnic", export: false },
    { header: "Status Comment", key: "statuscomment", export: false },
    {
      header: "Order Summary (Name | Quantity | Price)",
      key: "order_items",
      export: false,
    },
  ],
  ordersTypeList = [
    { value: "", label: "All Order Types" },
    { value: "1", label: "Pick Up" },
    { value: "0", label: "Delivery" },
    { value: "1", label: "Canada Post" },
  ],
  subscriptionsStatusList = [
    { label: "All Statuses", value: "" },
    { label: "Inactive", value: "inactive" },
    { label: "Active", value: "active" },
  ],
  subscriptionsTypeList = [
    { label: "All Subscriptions", value: "" },
    { label: "Bi-weekly", value: "bi-weekly" },
    { label: "Weekly", value: "weekly" },
    { label: "Monthly", value: "monthly" },
  ],
  suscriptionStatusObject = {
    ACTIVE: "active",
    INACTIVE: "inactive",
  },
  keysOfItems = [
    {
      key: "image",
      value: "Image",
      align: "left",
      selected: true,
      width: "10%",
    },
    {
      key: "name",
      value: "Name",
      align: "left",
      selected: true,
      width: "30%",
    },
    {
      key: "category",
      value: "Category",
      align: "left",
      selected: true,
      width: "15%",
    },
    {
      key: "price",
      value: "Price",
      align: "right",
      selected: true,
      // width: "10%",
    },
    {
      key: "discount_display",
      value: "Discount",
      align: "right",
      selected: true,
      width: "18%",
    },
    {
      key: "tax",
      value: "Tax %",
      align: "right",
      selected: true,
      width: "10%",
    },
    {
      key: "status",
      value: "Status",
      align: "left",
      selected: true,
      width: "10%",
    },
    {
      key: "carton",
      value: "Carton Size",
      selected: false,
      align: "right",
    },
    {
      key: "pallet",
      value: "Pallet Size",
      selected: false,
      align: "right",
    },
    {
      key: "carton_price",
      value: "Carton Price",
      selected: false,
      align: "right",
    },
    {
      key: "pallet_price",
      value: "Pallet Price",
      selected: false,
      align: "right",
    },
    {
      key: "product_code",
      value: "Product Code",
      selected: false,
      align: "right",
    },
    {
      key: "sku",
      value: "SKU",
      selected: false,
      align: "right",
    },
    {
      key: "upc",
      value: "Universal Product Code",
      selected: false,
      align: "right",
    },
    {
      key: "suggestions",
      value: "Suggestions",
      selected: false,
      align: "left",
    },
    {
      key: "unit_price",
      value: "Unit price",
      selected: false,
      align: "right",
    },
    {
      key: "item_weight",
      value: "Item Weight",
      selected: false,
      align: "right",
    },
    {
      key: "order_limit",
      value: "Order Limit",
      selected: false,
      align: "right",
    },
    {
      key: "inv_limit",
      value: "Inventory Limit",
      selected: false,
      align: "right",
    },
    {
      key: "price_per",
      value: "Price Per",
      selected: false,
      align: "right",
    },
    {
      key: "options",
      value: "Option Set",
      selected: false,
      align: "center",
    },
    {
      key: "",
      value: "Actions",
      align: "right",
      selected: true,
      width: "10%",
    },
  ],
  filtersMap: FiltersProps[] = [
    {
      name: "Items",
      key: "items",
      options: [
        { label: "All", value: "all_images" },
        { label: "With Images", value: "with_images" },
        { label: "Without Images", value: "without_images" },
      ],
    },
    {
      name: "Items Stock",
      key: "items_stock",
      options: [
        { label: "All", value: "all_of_stock" },
        { label: "In Stock", value: "in_stock" },
        { label: "Out of Stock", value: "out_of_stock" },
      ],
    },
    {
      name: "Visibility on Platform",
      key: "visibility_on_platform",
      options: [
        { label: "All", value: "all_platforms" },
        { label: "None", value: "none" },
        { label: "Web", value: "web" },
        { label: "POS", value: "pos" },
      ],
    },
    {
      name: "Discount",
      key: "discount",
      options: [
        { label: "All", value: "all_of_discount" },
        { label: "With", value: "with_discount" },
        { label: "Without", value: "without_discount" },
      ],
    },
  ],
  // Product Export Columns
  itemExportColumns = [
    { header: "Product ID", key: "menu_item_id", export: true },
    { header: "Category ID", key: "menu_cat_id", export: true },
    { header: "Name", key: "name", export: true },
    { header: "Category", key: "category", export: true },
    { header: "Brand", key: "item_brand", export: false },
    { header: "Price", key: "price", export: true },
    { header: "Description", key: "desc", export: true },
    { header: "Discount", key: "discount_display", export: true },
    { header: "Discount Start", key: "discount_start_at", export: true },
    { header: "Discount Expiry", key: "discount_expiry", export: true },
    { header: "Tax %", key: "tax", export: true },
    { header: "Weight", key: "item_weight", export: false },
    { header: "SKU", key: "sku", export: false },
    { header: "Status", key: "status", export: true },
    { header: "Carton Size", key: "carton", export: false },
    { header: "Pallet Size", key: "pallet", export: false },
    { header: "Carton Price", key: "carton_price", export: false },
    { header: "Pallet Price", key: "pallet_price", export: false },
    { header: "Product Code", key: "product_code", export: false },
    { header: "Universal Product Code", key: "upc", export: false },
    { header: "Unit price", key: "unit_price", export: false },
    { header: "Order Limit", key: "order_limit", export: false },
    { header: "Inventory Limit", key: "inv_limit", export: false },
    { header: "Price Per", key: "price_per", export: false },
    { header: "Minimum Quantity", key: "min_qty", export: false },
    { header: "Maximum Distance", key: "max_distance", export: false },
    { header: "Image", key: "image", export: false },
  ],
  productSeoExport = [
    { header: "Product ID", key: "menu_item_id" },
    { header: "Name", key: "name" },
    ...SEOExportKeys,
  ],
  categorySeoExport = [
    { header: "Category ID", key: "category_id" },
    { header: "Name", key: "category_name" },
    ...SEOExportKeys,
  ],
  brandSeoExport = [
    { header: "Brand ID", key: "id" },
    { header: "Name", key: "name" },
    ...SEOExportKeys,
  ],
  areasExport = [
    { header: "Areas", key: "secondary_locality" },
    { header: "Charges", key: "delivery_charges" },
  ],
  areaExport = [
    { header: "Areas", key: "area" },
    { header: "Charges", key: "charges" },
  ],
  customerExport = [
    { header: "Customer ID", key: "user_id" },
    { header: "Name", key: "user_name" },
    {
      header: "User Email",
      key: "user_email",
    },
    {
      header: "City",
      key: "user_city",
    },
    {
      header: "Created_at",
      key: "created_at",
    },
  ],
  reservationExport = [
    { header: "Reservation ID", key: "reservation_id" },
    { header: "Date", key: "date" },
    {
      header: "Time",
      key: "time",
    },
    {
      header: "Name",
      key: "user_name",
    },
    {
      header: "Guests",
      key: "guests",
    },
    {
      header: "Status",
      key: "status",
    },
  ],
  cartsExport = [
    { header: "Cart ID", key: "orderid" },
    { header: "Date/Time", key: "date" },
    {
      header: "Email",
      key: "email",
    },
    {
      header: "Phone #",
      key: "mobile_phone",
    },
    {
      header: "Order Type",
      key: "order_type",
    },
    {
      header: "Source",
      key: "source",
    },
    {
      header: "Discount",
      key: "discount",
    },
    {
      header: "Delivery Charges",
      key: "delivery_charges",
    },
    {
      header: "Tax",
      key: "tax",
    },
    {
      header: "Grand Total",
      key: "gtotal",
    },
    {
      header: "Cart Items",
      key: "cart_items",
    },
  ],
  stockExport = [
    { header: "Product ID", key: "product_id" },
    { header: "Product Code", key: "product_code" },
    { header: "Category", key: "category" },
    { header: "Product Name", key: "dname" },
    { header: "Quantity on Hand", key: "available" },
    { header: "New Quantity", key: "" },
    { header: "Unit Cost", key: "price" },
    { header: "Expiry Date", key: "expiry_date" },
  ],
  weightUnits = [
    { label: "Gram (g)", value: "g" },
    { label: "Kilogram (kg)", value: "kg" },
    { label: "Litre (l)", value: "l" },
    { label: "Milliliter (ml)", value: "ml" },
    { label: "Milligram (mg)", value: "mg" },
    { label: "Pound (lb)", value: "lb" },
  ],
  taxTypes = [
    { label: "HST", value: "1" },
    { label: "GST", value: "2" },
    { label: "VAT", value: "3" },
  ],
  canadaPostMaximumDistance = 10000,
  // Bulk Actions dropdown in items
  bulkActions = [
    {
      label: "Bulk Actions",
      value: "bulkActions",
    },
    {
      label: "Item Available",
      value: "itemAvailable",
    },
    {
      label: "Item Un-Available",
      value: "itemUnAvailable",
    },
    {
      label: "Brand Association",
      value: "brandAssociation",
    },
    {
      label: "Brand Dis-Association",
      value: "brandDisAssociation",
    },
    {
      label: "Category Association",
      value: "categoryAssociation",
    },
  ],
  // ImportExport dropdown in items
  dropdownImportExport = [
    {
      label: "Import/Export",
      value: "import_export",
    },
    {
      label: "Import New Items",
      value: "Import New Items",
    },
    {
      label: "Update Existing Item",
      value: "Update Existing Item",
    },
    // TODO:  will active once export pdf design ready
    // {
    //   label: "Export items(.pdf)",
    //   value: "Export items(.pdf)",
    // },
    {
      label: "Export Items (.xlsx)",
      value: "Export Items (.xlsx)",
    },
    {
      label: "Download Sample",
      value: "Download Sample",
    },
    // TODO: will active once design ready
    // {
    //   label: "Download Flyer",
    //   value: "Download Flyer",
    // },
  ],
  // advance options dropdown in product items
  productsAdvanceOptions = [
    {
      label: "Advance Options",
      value: "advanceOptions",
    },
    {
      label: "Time Bounded Products",
      value: "timeBoundedProducts",
    },
    {
      label: "Wishlist",
      value: "wishlist",
    },
  ],
  // ImportExport dropdown in settings => orderSettings => deliveryAreas
  deliveryAreasImportExport = [
    {
      label: "Import/Export",
      value: "import_export",
    },
    {
      label: "Import Delivery Areas",
      value: "Import Delivery Areas",
    },
    {
      label: "Export Delivery Areas",
      value: "Export Delivery Areas",
    },
    {
      label: "Download Sample",
      value: "Download Sample",
    },
  ],
  seoImportExport = [
    {
      label: "Import/Export",
      value: "import_export",
    },
    {
      label: "Import Tags (.xlsx)",
      value: "Import Tags (./xlsx)",
    },
    {
      label: "Export Tags (.xlsx)",
      value: "Export Tags (.xlsx)",
    },
  ],
  categoryColumns = [
    {
      key: "color",
      value: "Color",
      align: "left",
      width: "5%",
      selected: true,
    },
    {
      key: "image",
      value: "Image",
      align: "left",
      width: "15%",
      selected: true,
    },
    {
      key: "category_name",
      value: "Category",
      align: "left",
      width: "40%",
      selected: true,
    },
    {
      key: "display_source",
      value: "Availability",
      align: "left",
      width: "15%",
      selected: true,
    },
    {
      key: "products_count",
      value: "No. of Items",
      align: "right",
      width: "15%",
      selected: true,
    },
    {
      key: "",
      value: "Actions",
      align: "right",
      width: "15%",
      selected: true,
    },
  ],
  bannerColumns = [
    {
      key: "image_url",
      value: "Image",
      align: "left",
      width: "25%",
      selected: true,
    },
    {
      key: "source",
      value: "Platform",
      align: "left",
      width: "10%",
      selected: true,
    },
    {
      key: "datetime_from",
      value: "From",
      align: "left",
      width: "20%",
      selected: true,
    },
    {
      key: "datetime_to",
      value: "To",
      align: "left",
      width: "20%",
      selected: true,
    },
    {
      key: "status",
      value: "Display ON/OFF",
      align: "left",
      width: "15%",
      selected: true,
    },
    {
      key: "",
      value: "Actions",
      align: "right",
      width: "10%",
      selected: true,
    },
  ],
  bannerPlatformsList = [
    { label: "All (Desktop/Mobile Responsive and App)", value: "All" },
    { label: "Web (Desktop Only)", value: "Web" },
    { label: "Web (Mobile Responsive Only)", value: "Mobile" },
    { label: "App", value: "App" },
    { label: "Email", value: "Email" },
  ],
  associationOptions = [
    { label: "Brand", value: "brand" },
    { label: "Category", value: "category" },
    { label: "Item", value: "menu_item" },
  ],
  staffAttendanceDetailsColumns = [
    { header: "Clock In", key: "clock_in" },
    { header: "Clock Out", key: "clock_out" },
    { header: "Break Time", key: "breaks" },
  ],
  reviewListingColumns = [
    { header: "Date & Time", key: "datetime" },
    { header: "Product", key: "product_name" },
    { header: "Rating", key: "rating" },
    { header: "Comment", key: "comment" },
    { header: "Customer Name", key: "customer_name" },
  ],
  businessReviewListingColumns = [
    { header: "Date & Time", key: "dateTime" },
    { header: "Customer Name", key: "name" },
    { header: "Email", key: "email" },
    { header: "Phone", key: "phone" },
    { header: "Rating", key: "rating" },
    { header: "Comment", key: "comment" },
  ],
  orderTypes = [
    { label: "Pick up", value: "pickup" },
    { label: "Delivery", value: "delivery" },
  ],
  reservationSMSStatus = [
    { label: "Pending", value: "pending" },
    { label: "Confirmed", value: "confirmed" },
    { label: "Cancel", value: "cancel" },
  ],
  businessHoursTypes = [
    { label: "All types", value: "hours,pickup" },
    { label: "Business hours", value: "hours" },
    { label: "Pick up hours", value: "pickup" },
  ],
  reservationSlots = [
    { label: "12:00 am", value: "00:00" },
    { label: "12:30 am", value: "00:30" },
    { label: "01:00 am", value: "01:00" },
    { label: "01:30 am", value: "01:30" },
    { label: "02:00 am", value: "02:00" },
    { label: "02:30 am", value: "02:30" },
    { label: "03:00 am", value: "03:00" },
    { label: "03:30 am", value: "03:30" },
    { label: "04:00 am", value: "04:00" },
    { label: "04:30 am", value: "04:30" },
    { label: "05:00 am", value: "05:00" },
    { label: "05:30 am", value: "05:30" },
    { label: "06:00 am", value: "06:00" },
    { label: "06:30 am", value: "06:30" },
    { label: "07:00 am", value: "07:00" },
    { label: "07:30 am", value: "07:30" },
    { label: "08:00 am", value: "08:00" },
    { label: "08:30 am", value: "08:30" },
    { label: "09:00 am", value: "09:00" },
    { label: "09:30 am", value: "09:30" },
    { label: "10:00 am", value: "10:00" },
    { label: "10:30 am", value: "10:30" },
    { label: "11:00 am", value: "11:00" },
    { label: "11:30 am", value: "11:30" },
    { label: "12:00 pm", value: "12:00" },
    { label: "12:30 pm", value: "12:30" },
    { label: "01:00 pm", value: "13:00" },
    { label: "01:30 pm", value: "13:30" },
    { label: "02:00 pm", value: "14:00" },
    { label: "02:30 pm", value: "14:30" },
    { label: "03:00 pm", value: "15:00" },
    { label: "03:30 pm", value: "15:30" },
    { label: "04:00 pm", value: "16:00" },
    { label: "04:30 pm", value: "16:30" },
    { label: "05:00 pm", value: "17:00" },
    { label: "05:30 pm", value: "17:30" },
    { label: "06:00 pm", value: "18:00" },
    { label: "06:30 pm", value: "18:30" },
    { label: "07:00 pm", value: "19:00" },
    { label: "07:30 pm", value: "19:30" },
    { label: "08:00 pm", value: "20:00" },
    { label: "08:30 pm", value: "20:30" },
    { label: "09:00 pm", value: "21:00" },
    { label: "09:30 pm", value: "21:30" },
    { label: "10:00 pm", value: "22:00" },
    { label: "10:30 pm", value: "22:30" },
    { label: "11:00 pm", value: "23:00" },
    { label: "11:30 pm", value: "23:30" },
  ],
  customReportActions = [
    {
      label: "Select Action",
      value: "selectAction",
    },
    {
      label: "Excel Export",
      value: "excelExport",
    },
  ],
  bulkPrint = [
    {
      label: "Bulk Print",
      value: "bulk_print",
    },
    {
      label: "Pickup Slip",
      value: "pickup_slip",
    },
    {
      label: "Packing Slip",
      value: "packing_slip",
    },
  ],
  twelveHourTimeArray = [
    "11pm",
    "10pm",
    "9pm",
    "8pm",
    "7pm",
    "6pm",
    "5pm",
    "4pm",
    "3pm",
    "2pm",
    "1pm",
    "12pm",
    "11am",
    "10am",
    "9am",
    "8am",
    "7am",
    "6am",
    "5am",
    "4am",
    "3am",
    "2am",
    "1am",
    "12am",
  ],
  weekdaysOrder = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  defaultData = {
    "12am": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "1am": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "2am": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "3am": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "4am": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "5am": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "6am": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "7am": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "8am": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "9am": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "10am": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "11am": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "12pm": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "1pm": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "2pm": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "3pm": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "4pm": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "5pm": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "6pm": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "7pm": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "8pm": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "9pm": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "10pm": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
    "11pm": { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 },
  },
  getHeatMapGradients = [
    "rgba(111, 250, 107, 0.19)",
    "rgba(137, 203, 185, 1)",
    "rgba(154, 171, 215, 1)",
    "rgba(129, 2520, 89, 1)",
    "rgba(143, 252, 78, 1)",
    "rgba(220, 253, 45, 1)",
    "rgba(255, 196, 29, 1)",
    "rgba(255, 97, 14, 1)",
    "rgba(233, 115, 148, 1)",
    "rgba(230, 91, 130, 1)",
    "rgba(243, 76, 7, 1)",
    "rgba(226, 68, 113, 1)",
    "rgba(223, 44, 95, 1)",
  ],
  customFilters = {
    group_by: { label: "", value: "" },
    week: { label: "", value: "" },
    branch_id: { label: "", value: "" },
    restaurant_city: { label: "", value: "" },
    restaurant_area: { label: "", value: "" },
    restaurant_country: { label: "", value: "" },
    type: { label: "", value: "" },
    order_source: { label: "", value: "" },
    pay_owner: { label: "", value: "" },
    pay_type: { label: "", value: "" },
    reference: { label: "", value: "" },
    custom_code: { label: "", value: "" },
    eatout_manager: { label: "", value: "" },
    pos_id: { label: "", value: "" },
    user_city: { label: "", value: "" },
    user_country: { label: "", value: "" },
    user_area: { label: "", value: "" },
    order_item: { label: "", value: "" },
    brand_id: { label: "", value: "" },
    category_id: { label: "", value: "" },
    status: { label: "", value: "" },
    payment_type: { label: "", value: "" },
  },
  initialAmountError = {
    minAmount: "",
    maxAmount: "",
    charges: "",
  },
  deliveryChargesTypes = [
    { label: "Flat", value: "flat" },
    { label: "Areas", value: "locality" },
    { label: "Geo Ranges", value: "geo_range" },
    { label: "Weight", value: "weight" },
  ],
  deliveryOptions = {
    FLAT: "flat",
    AREAS: "locality",
    GEORANGE: "geo_range",
    WEIGHT: "weight",
  },
  newItemsRequireColumns = [
    "Category",
    "Brand",
    "Product Name",
    "Price",
    "Description",
    "SKU",
    "Discount",
    "Discount Start",
    "Discount Expiry",
    "Tax %",
    "Pallet Size",
    "Pallet Price",
    "Carton Size",
    "Carton Price",
    "Weight",
    "Product Code",
    "Universal Product Code",
    "Order Limit",
    "Inventory Limit",
    "Minimum Quantity",
    "Max Distance",
    "Image",
  ],
  // conversion rates to grams
  conversionRates: { [key: string]: number } = {
    g: 1,
    kg: 1000,
    l: 1000,
    ml: 1,
    mg: 0.001,
    lb: 453.592,
  };

export const printerOptions = [
  { label: "Standard Printer", value: "standard" },
  { label: "Thermal Printer", value: "thermal" },
];

export const bizDomains = {
  TOSSDOWN: "tossdown",
  ORDRZ: "ordrz",
  STAGING_DOMAIN: ".staging.tossdown.site",
  LIVE_DOMAIN: ".tossdown.site",
};

export const preAuthOrderStatus = {
  label: "Pre-Authorized",
  value: "Pre-Authorized",
};

export const exportKeys = {
  DEFAULT: "import_export",
  AREA: "Export Delivery Areas",
};

export const paymentMethods = {
  GLOBAL: "global_payment_preauth",
};

export const loyaltyInitialCustomRule = {
  value: { label: "", value: "" },
  points: "",
};

export const dateTimeFormats = {
  DATE: "YYYY-MM-DD",
  TIME: "HH:mm:ss",
  TIME_MERIDIAN: "h:mm:ss A",
  MINUTES_TIME_MERIDIAN: "h:mm A",
  INITIAL_DATE_TIME: "0000-00-00 00:00:00",
  DATE_TIME: "YYYY-MM-DDTHH:mm:ss[Z]",
  DAY_MONTH: "DD MMM",
};

export const orderStatus = {
  PENDING: "Pending",
  CONFIRMED: "Confirmed",
  CANCEL: "Cancel",
};

export const orderSource = {
  ANDROID_APP: { label: "Android app", value: "android_app" },
  IOS_APP: { label: "iOS app", value: "ios_app" },
  WEB: { label: "Web", value: "web" },
  POS: { label: "POS", value: "POS" },
  KIOSK: { label: "Kiosk", value: "Kiosk" },
};

// mapping order sources (keys used as stored in database)
export const sourceMapping: Record<string, string> = {
  web: "web",
  ios_app: "app",
  android_app: "app",
  Kiosk: "store",
  POS: "store",
};

export const paymentMode = {
  ONLINE: "Online Payment",
  COD: "COD",
  Bank_Transfer: "Bank Transfer",
};

export const colors = {
  red: { light: "#FBE9E7", dark: "#D84315" },
  green: { light: "#C7FFD6", dark: "#00C853" },
  yellow: { light: "#FFF4D0", dark: "#EEB304" },
  black: { light: "#00000066", dark: "#000000" },
};

export const initialBusinessStats: BusinessStatsResponse = {
  averageOrderValue: 0,
  branchWiseSummary: [],
  cancelledOrders: 0,
  cancelledSales: 0,
  currency: "",
  dailyMetrics: [],
  dailyMetricsBySource: [],
  heatMap: [],
  pendingOrders: 0,
  pendingSales: 0,
  topAreas: [],
  topCategories: [],
  topProducts: [],
  totalCustomers: 0,
  totalOrders: 0,
  totalSales: 0,
};

export const skeletonAnimation = "wave";
export const border = "1px solid #EEEEEE";
export const borderRadius = "8px";

export {
  settingsInfo,
  integrationInfo,
  orderSettings,
  businessInfoSettings,
  communicationSettings,
  ordersCommunicationSettings,
  reservationSettings,
} from "./UIObjects";
